<template>
  <div class="login-box" :style="{'display': (showPage?'':'none')}">
    <div class="login-p" v-if="loginState">登录</div>
    <div class="login-p" v-if="!loginState">注册</div>
    <router-link to="/" class="login-logo">
      <van-image width="3.21rem" height="0.6rem" :src="logo"></van-image>
    </router-link>
    <div class="login-form" v-if="loginState">
      <van-field v-model="loginForm.username" :left-icon="uIcon" clearable placeholder="请输入手机号码" />
      <van-field
        :left-icon="pIcon"
        label-width="3rem"
        v-model="loginForm.yzm"
        placeholder="请输入短信验证码"
        v-if="loginMode =='2' "
      >
        <van-button
          slot="button"
          size="small"
          type="default"
          @click="getCodeBefore(loginForm.username)"
        >{{ saveYzm }}</van-button>
      </van-field>
      <van-field
        v-model="loginForm.pwd"
        v-if="loginMode =='1' "
        :left-icon="pIcon"
        type="password"
        clearable
        placeholder="请输入密码"
      />
    </div>
    <div class="login-form" v-if="!loginState">
      <van-field v-model="signForm.username" :left-icon="sIcon" clearable placeholder="请输入手机号码" />
      <van-field
        :left-icon="uIcon"
        label-width="3rem"
        v-model="signForm.phone"
        placeholder="请输入手机号码"
      />
      <van-field
        :left-icon="uIcon"
        label-width="3rem"
        v-model="signForm.yzm"
        placeholder="请输入短信验证码"
      >
        <van-button
          slot="button"
          size="small"
          type="default"
          @click="getCodeBefore(signForm.username)"
        >{{ saveYzm }}</van-button>
      </van-field>
    </div>
    <div class="login-btn" v-if="loginState" @click="login">
      <span>立即登录</span>
      <img src="~@/assets/images/login/arr.png" alt />
    </div>
    <div class="login-btn no-login" v-if="!loginState">
      <span>立即注册</span>
      <img src="~@/assets/images/login/arr.png" alt />
    </div>
    <div class="ligin-foot-p" v-if="false">
      <div class="left-p" v-if="!loginState">
        已有账号？
        <a href="javascript:;" @click="loginState = true">马上登陆</a>
      </div>
      <!-- <div class="right-p" v-if="loginState">
        还没有账号？
        <a href="javascript:;" @click="loginState = false">立即注册</a>
      </div>-->
    </div>
    <div class="bottom-other-login">
      <div class="order-line"></div>
      <div class="order-p">其他登录方式</div>
      <div class="order-line"></div>
    </div>
    <div class="other-login-btnbox">
      <div class="other-login-btn" @click="setLoginMode(1)" v-show="loginMode == '1'">
        <img src="@/assets/images/login/codelogin.png" alt class="this-img" />
        <div class="this-p">验证码登录</div>
      </div>
      <div
        class="other-login-btn"
        style="display: none"
        @click="setLoginMode(2)"
        v-show="loginMode == '2'"
      >
        <img src="@/assets/images/login/passlogin.png" alt class="this-img" />
        <div class="this-p">密码登录</div>
      </div>
    </div>
    <!-- 图形验证码 -->
    <van-dialog
      v-model="verifyCodeShow"
      title="请输入图形验证码"
      show-cancel-button
      :beforeClose="beforeClose"
      @confirm="getCode(signForm.username)"
      class="verifyCodeDialog"
    >
      <br />
      <div style="text-align:center;">
        <img
          :src="verifyCodeImageBase64"
          style="display: initial;"
          @click="getVerifyCodeImageBase64()"
        />
      </div>
      <van-field v-model="verifyCode" label="验证码" placeholder="请输入图形验证码" maxlength="6" />
    </van-dialog>
  </div>
</template>

<script>
import { Toast, Field, Image, Button, Dialog, CellGroup } from "vant";
import logo from "@/assets/images/login/logo.png";
import uIcon from "@/assets/images/login/p.png";
import pIcon from "@/assets/images/login/pass.png";
import sIcon from "@/assets/images/login/u.png";
import Cookies from "js-cookie";
import {
  getToken,
  setToken,
  removeToken,
  setRole,
  getOpenid,
  setOpenid
} from "@/utils/auth"; // get token from cookie
import { getAccessToken } from "@/api/wechat";
import { sendCode, verifyCodeImageBase64 } from "@/api/common";
import { logIn, logInBindOpenId /*, autoLogin*/ } from "@/api/account/account";
import moment from "moment";

export default {
  name: "login",
  data() {
    return {
      msg: "登录注册",
      logo: logo,
      uIcon: uIcon,
      pIcon: pIcon,
      sIcon: sIcon,
      saveYzm: "发送验证码",
      loginMode: 1, // 1为密码登录 2为验证码登录
      loginState: true, // 是否登录状态
      loginForm: {
        username: "",
        yzm: "",
        pwd: ""
      },
      signForm: {
        username: "",
        phone: "",
        yzm: ""
      },
      showPage: true,
      codeTime: 0, // 发送验证码的时间
      timeOut: "", // 倒计时事件
      access_token: "", //网页授权接口调用凭证
      curOpenid: "",
      //图形验证码
      curMobile: "",
      verifyCodeShow: false,
      verifyCode: "",
      verifyCodeImageBase64: "",
      openid: ""
    };
  },
  created() {
    let self = this;
    self.openid = Cookies.get("openid");
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {      
      if (!self.openid) {
        self.redirectToWeixin();
      }
    }

  },
  methods: {
    //跳转到微信网页授权
    redirectToWeixin() {
      const url = `${window.location.origin + window.location.pathname}`;
      window.location.href = GetWechatAuthUrl(url);
    },
    // 图形验证码
    getVerifyCodeImageBase64: function() {
      verifyCodeImageBase64()
        .then(response => {
          const { code, msg, data } = response;
          if (code >= 0) {
            //console.info('verifyCodeImageBase64 -> data', data)
            this.verifyCodeImageBase64 = data.base64String;
          }
        })
        .catch(response => {
          this.tips(`${response.msg}`);
        });
    },
    beforeClose(action, done) {
      if (action == "cancel") done();
      else done(false);
    },
    getCodeBefore: function(mobile) {
      let self = this;
      if (!self.regPhoneNumber(mobile)) {
        self.tips("请确保手机号码是正确的！");
        return;
      }
      if (self.codeTime !== 0) {
        self.tips("请勿重复点击发送验证码！");
        return;
      }
      this.verifyCodeShow = true;
      this.getVerifyCodeImageBase64();
      this.curMobile = mobile;
    },
    // 设置切换登录模式 1为密码登录 2为验证码登录
    setLoginMode: function(state) {
      let self = this;
      self.loginMode = state == 1 ? 2 : 1;
    },
    // yzm
    getCode: function() {
      const mobile = this.curMobile;
      //console.info('signForm', this.signForm)
      let self = this;
      if (!self.regPhoneNumber(mobile)) {
        self.tips("请确保手机号码是正确的！");
        return;
      }
      if (self.codeTime !== 0) {
        self.tips("请勿重复点击发送验证码！");
        return;
      }
      if (this.verifyCode == "") {
        self.tips("请输入图形验证码！");
        return;
      }
      sendCode(mobile, this.verifyCode)
        .then(response => {
          const { code, msg, data } = response;
          if (code >= 0) {
            console.info("sendCode -> data", data);
            this.verifyCodeShow = false;
            self.tips("验证码已发送，请注意查收");
            self.codeTime = 60;
            // 自调用
            self.timeOut = setInterval(() => {
              self.codeTime--;
              self.saveYzm = self.codeTime + "s";
              if (self.codeTime === 0) {
                clearInterval(self.timeOut);
                self.saveYzm = "发送验证码";
              }
            }, 1000);
          }
        })
        .catch(response => {
          this.tips(`${response.msg}`);
        });
    },
    // 登录
    login() {
      let self = this;
      console.info("login", this.loginForm);
      let { username, yzm, pwd } = this.loginForm;
      if (username == "") {
        this.tips("请输入手机号码");
        return;
      }
      let code = "";
      if (this.loginMode == 1) {
        //密码登录
        if (pwd == "") {
          this.tips("请输入密码");
          return;
        }
        code = pwd;
      } else {
        //验证码登录
        if (yzm == "") {
          this.tips("请输入短信验证码");
          return;
        }
        code = yzm;
      }

      const parm = {
        mobile: username,
        code: code,
        loginMode: this.loginMode
      };
      console.info("parm", parm);
      this.load(true, "加载中...");
      logIn(parm)
        .then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            // Cookies.set("lshoot-qupaipai-hkm-account-token",data.token);
            if (!data.openid && self.openid) {              
              //自动绑定OpenId
              logInBindOpenId(self.openid).then(res => {
                this.loginSuccessCallback(data);
              });
            }
            else {
              this.loginSuccessCallback(data);
            }          
          }
        })
        .catch(response => {
          this.load(false);
          //this.tips(response.msg);
          Toast.fail({ duration: 1000 * 3, message: `${response.msg}` });
        });
    },
    // // 自动登录
    // autoLogin(openid, machineCode) {
    //   console.info("autoLogin", openid, machineCode);
    //   const parm = {
    //     openid: openid,
    //     machineCode: machineCode
    //   };

    //   this.load(true, "自动登录中...");
    //   autoLogin(parm)
    //     .then(response => {
    //       this.load(false);
    //       const { code, msg, data } = response;
    //       if (code >= 0) {
    //         const that = this;
    //         setTimeout(function() {
    //           that.loginSuccessCallback(data);
    //         }, 1000 * 1);
    //       }
    //     })
    //     .catch(response => {
    //       this.load(false);
    //       //this.tips(response.msg);
    //       Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
    //     });
    // },
    // 登录成功后的操作
    loginSuccessCallback(data) {
      console.info("登录成功，跳转页面...");
      window.localStorage.isAutoLogin = "true";
      //setOpenid(this.curOpenid, moment().add(365, 'days').format('YYYY-MM-DD'))
      setToken(
        data.token,
        moment()
          .add(365, "days")
          .format("YYYY-MM-DD")
      );
      setRole(
        data.roles.join(","),
        data.curRole,
        moment()
          .add(365, "days")
          .format("YYYY-MM-DD")
      );
      let { redirect } = this.$route.query;
      //如果登录的是商家，而且上一页面是摄影师页面，则登录后要跳转至商家中心
      if (data.curRole == "store")
        window.location.href =
          !redirect || redirect.toLowerCase().indexOf("/grapher") == 0
            ? "/Store/Other"
            : redirect;
      else if (data.curRole == "grapher")
        window.location.href =
          !redirect || redirect.toLowerCase().indexOf("/store") == 0
            ? "/Grapher/Center"
            : redirect;
    }
  },
  components: {
    "van-field": Field,
    "van-image": Image,
    "van-button": Button,
    [Dialog.Component.name]: Dialog.Component,
    "van-cell-group": CellGroup
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
.login-box {
  background: url(~@/assets/images/login/bg.png) top left no-repeat #000;
  background-size: 7.5rem auto;
  width: 100%;
  height: 100%;
  padding-left: 0.5rem;
  .login-p {
    height: 0.35rem;
    font-family: PingFang-SC-Bold;
    font-size: 0.38rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.4rem;
    letter-spacing: 0rem;
    color: #333333;
    padding-top: 0.67rem;
  }
  .login-logo {
    margin-top: 0.64rem;
    margin-bottom: 1.14rem;
    display: block;
  }
  .login-form {
    width: 5.8rem;
    margin-left: -0.3rem;
    position: relative;
    .van-cell {
      background: transparent;
      height: 55px;
      align-items: center;
      .van-button--small {
        span {
          transform: scale(0.9, 0.9);
        }
      }
    }
    &::after {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0;
      bottom: 0;
      left: 15px;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
  }
  .login-btn {
    font-family: PingFang-SC-Medium;
    font-size: 0.32rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.38rem;
    letter-spacing: 0rem;
    color: #ffffff;
    text-align: center;
    width: 6.07rem;
    height: 0.8rem;
    line-height: 0.8rem;
    background: rgba(0,149,255,1);
    background: #0095ff;
    opacity: 0.8;
    display: flex;
    margin-top: 1.48rem;
    border-radius: 0.5rem;
    &.no-login {
      margin-top: 1.6rem;
    }
    span {
      display: block;
      width: 3.5rem;
      text-align: right;
      margin-right: 0.3rem;
    }
    img {
      width: 0.61rem/1.4;
      height: 0.46rem/1.4;
      display: block;
      margin-top: 0.24rem;
    }
    &:act {
      opacity: 1;
    }
  }
  .bottom-other-login {
    text-align: center;
    margin-top: 0.5rem;
    width: 6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .order-line {
      width: 1rem;
      height: 1px;
      background: #ddd;
      margin: 0 0.2rem;
    }
    .order-p {
      color: #bbb;
      font-size: 0.24rem;
    }
  }
  .other-login-btnbox {
    margin-top: 0.3rem;
    width: 6rem;
    .other-login-btn {
      display: block;
      text-align: center;
      width: 2rem;
      margin: 0 auto;
      opacity: 0.6;
      &:active {
        opacity: 0.8;
      }
      img {
        width: 0.4rem;
        margin: 0 auto;
        padding-bottom: 0.1rem;
      }
      .this-p {
        margin-top: 0.1rem;
        font-size: 0.24rem;
        color: #fff;
      }
    }
  }

  .ligin-foot-p {
    height: 0.28rem;
    font-family: PingFang-SC-Medium;
    font-size: 0.26rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.34rem;
    letter-spacing: 0rem;
    color: #ffffff;
    width: 100%;
    margin-top: 2.6rem;
    .left-p {
      width: 100%;
      text-align: left;
    }
    .right-p {
      width: 85%;
      text-align: right;
    }
    a {
      color: #fff;
      border-bottom: 1px solid #fff;
    }
  }
}
.verifyCodeDialog {
  top: 20%;
}
</style>


// WEBPACK FOOTER //
// src/views/user/login.vue